import React, {Component} from 'react';
import PropTypes from "prop-types";
import _ from 'lodash';

import {COLUMN_SHAPE} from '../../utilities/columns'

/**
 * Component to render the table header
 *
 * @example
 * <TableHeader columns={this.props.columns}/>
 */
export default class TableHeader extends Component {

  static propTypes = {
    columns: PropTypes.arrayOf(COLUMN_SHAPE)
  };

  render() {
    const headerColumns = _.map(this.props.columns, col => (
      <th key={col.field} className={col.className} role="columnheader" scope="col">
        <div className="table-header-label">{col.label}</div>
      </th>
    ));

    return <tr>{headerColumns}</tr>;
  }
}
